import { render, staticRenderFns } from "./paidquery_qx.vue?vue&type=template&id=0ff9e5b4&scoped=true&"
import script from "./paidquery_qx.vue?vue&type=script&lang=js&"
export * from "./paidquery_qx.vue?vue&type=script&lang=js&"
import style0 from "./paidquery_qx.vue?vue&type=style&index=0&id=0ff9e5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9e5b4",
  null
  
)

export default component.exports